import { endNetwork, startNetwork } from 'redux/actions/network';
import * as actionTypes from 'redux/actionTypes/index';
import apiUtils from 'utils/api';
import { sendAuthenticatedRequest } from 'utils/auth/authenticatedRequest';
import { getHttpStatusFromError, isAuthenticationError } from 'utils/httpError';

const apiMiddleware =
  ({ dispatch }) =>
  (next) =>
  async (action) => {
    if (action.type !== actionTypes.API_REQUEST) {
      return next(action);
    }

    const { payload } = action;
    const { url, onSuccess, onFailure, label, data, method = 'GET' } = payload || {};

    dispatch(startNetwork(label));

    const handleSuccess = ({ body }) => {
      dispatch(endNetwork(label));

      if (onSuccess) {
        onSuccess(body, dispatch);
      }
    };

    const handleFailure = (error) => {
      const status = getHttpStatusFromError(error);
      if (status === 500 || status === undefined) {
        console.error('API error', error, action);
      }
      if (isAuthenticationError(error)) {
        console.warn('user unauthorized after token recovery');
      } else if (onFailure) {
        onFailure(error, dispatch);
      }

      dispatch(endNetwork(label));
    };

    sendAuthenticatedRequest({
      endpoint: url,
      execute: (requestAccessToken) =>
        apiUtils.request({
          method,
          url,
          data,
          accessToken: requestAccessToken,
        }),
    })
      .then(handleSuccess)
      .catch(handleFailure);

    return next(action);
  };

export default apiMiddleware;
